import { NgModule } from '@angular/core';
import { RenderBlocksModule } from 'render/render-blocks/render-blocks.module';
import { RenderSharedModule } from 'render/render-shared/render-shared.module';
import { SharedModule } from 'shared/shared.module';

import { PieceNewsletterRenderComponent } from './piece-newsletter-render.component';


export const pieceNewsletterRenderModuleEntryComponents = [
  PieceNewsletterRenderComponent
];

@NgModule({
  imports: [
    SharedModule,
    RenderSharedModule,
    RenderBlocksModule
  ],
  declarations: pieceNewsletterRenderModuleEntryComponents
})
export class PieceNewsletterRenderModule {}

export default pieceNewsletterRenderModuleEntryComponents;
